"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryClassSchema = exports.BoundaryClass = void 0;
const zod_1 = require("zod");
var BoundaryClass;
(function (BoundaryClass) {
    BoundaryClass["IC_AbsoluteMaximumRating"] = "ic.amr";
    BoundaryClass["IC_ElectricalCharacteristics"] = "ic.ec";
    BoundaryClass["IC_ElectricalCharacteristics_MeasurementPoint"] = "ic.ec.meas";
    BoundaryClass["IC_TTL"] = "ic.ttl";
    BoundaryClass["IC_TTL_INPUT"] = "ic.ttl.i";
    BoundaryClass["IC_TTL_INPUT_HIGH"] = "ic.ttl.ih";
    BoundaryClass["IC_TTL_INPUT_LOW"] = "ic.ttl.il";
    BoundaryClass["IC_TTL_OUTPUT"] = "ic.ttl.o";
    BoundaryClass["IC_TTL_OUTPUT_HIGH"] = "ic.ttl.oh";
    BoundaryClass["IC_TTL_OUTPUT_LOW"] = "ic.ttl.ol";
    BoundaryClass["MODE_SUPPLY_ON"] = "mode.supply.on";
    BoundaryClass["MODE_ENABLE_ON"] = "mode.enable.on";
})(BoundaryClass || (exports.BoundaryClass = BoundaryClass = {}));
exports.BoundaryClassSchema = zod_1.z.nativeEnum(BoundaryClass);
//# sourceMappingURL=BoundaryClass.js.map